import { ProductType } from "./ProductList";

export type ProductNeedsItem = {
    title: string
    details: string
}

export const CollabNeedList: string[] = [
    "collaboration.cleanWorkEnvironment",
    "collaboration.structureProcesses",
    "collaboration.automation",
    "collaboration.productivity",
    "collaboration.savingMoney",
    "collaboration.compliance",
    "collaboration.security"
];

export const MailNeedList: string[] = [
    "mail.noMess",
    "mail.higherSecurity",
    "mail.saveTime",
    "mail.endUserFocus",
    "mail.fasterProcess",
    "mail.compliance",
    "mail.fun"
];

export const MeetNeedList: string[] = [
    "meet.increaseProductivity",
    "meet.clearerCommunication",
    "meet.betterCollaboration",
    "meet.focusOnMatters",
    "meet.fun",
];

export const IdentityNeedList: string[] = [
    "identity.simplifiedIdentity",
    "identity.noDowntime",
    "identity.saveTime",
    "identity.enhancedSecurity",
    "identity.fullControlVisibility",
    "identity.auditReady",
    "identity.delegate"
];


export function getNeedsByType(product: ProductType): string[] {
    switch (product) {
        case ProductType.Collab:
            return CollabNeedList;
        case ProductType.Mail:
            return MailNeedList;
        case ProductType.Meet:
            return MeetNeedList;
        case ProductType.Identity:
            return IdentityNeedList;
        default:
            throw new Error('Invalid product type');
    }
}

export function getProductNeedsStatement(product: ProductType): string {
    switch (product) {
        case ProductType.Collab:
            return "collaboration.title";
        case ProductType.Mail:
            return "mail.title";
        case ProductType.Meet:
            return "meet.title";
        case ProductType.Identity:
            return "identity.title";
        default:
            throw new Error('Invalid product type');
    }
}
